import { Component, Inject, OnInit } from "@angular/core";
import { RemarkInfo } from "./overview-table.component";
import { OverviewService, PersonInfo } from "./overview.service";
import { Observable } from "rxjs";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { RemarkDialog } from "./remark-dialog.component";
import { StateService } from "@uirouter/angular";
import { YearAndMonth } from "../../services/activity.service";
import { ActivityRemarkService, ActivityRemarkKey } from "../../services/activity-remark.service";

@Component({
    selector: "overview",
    template: require('./overview.component.html'),
    providers: [OverviewService]
})
export class OverviewComponent implements OnInit {
    constructor(
        private overviewService: OverviewService,
        private matDialog: MatDialog,
        private stateService: StateService,
        private activityRemarkService: ActivityRemarkService,
        @Inject("workplaceId") public workplaceId: number,
        @Inject("workgroupId") public workGroupId: number,
        @Inject("year") public year: number,
        @Inject("month") public month: number) { }

    isLoading: Observable<boolean>;
    currentWorkplaceId: Observable<number>;
    currentYearAndMonth: Observable<YearAndMonth>;
    personInfo: Observable<PersonInfo[]>;

    ngOnInit(): void {
        this.isLoading = this.overviewService.isProcessing;
        this.currentWorkplaceId = this.overviewService.workplaceId;
        this.currentYearAndMonth = this.overviewService.yearAndMonth;
        this.personInfo = this.overviewService.personInfo;
    }

    showRemark(remarkInfo: RemarkInfo, workplaceId: number, personInfo: PersonInfo[]): void {
        const dialogRef = this.createRemarkDialog(remarkInfo.Year, remarkInfo.Month, personInfo);
        dialogRef.componentInstance.inputPersonId = remarkInfo.PersonId;
        dialogRef.componentInstance.inputDayOfMonth = remarkInfo.DayOfMonth;
        dialogRef.componentInstance.inputRemark = remarkInfo.Remark;
        dialogRef.afterClosed().subscribe((res: { remark: string; delete: boolean; }) =>
        {
            if (res) {
                this.processAndRefresh(() => {
                    const key: ActivityRemarkKey = {
                        WorkplaceId: workplaceId,
                        PersonId: remarkInfo.PersonId,
                        Year: remarkInfo.Year,
                        Month: remarkInfo.Month + 1,
                        Day: remarkInfo.DayOfMonth
                    };

                    if (res.delete) {
                        this.activityRemarkService.deleteActivityRemark(key).subscribe();
                    }
                    else {
                        this.activityRemarkService.updateActivityRemark({ Key: key, Remark: res.remark }).subscribe();
                    }
                });
            }
        });
    }

    newRemark(yearAndMonth: YearAndMonth, workplaceId: number, personInfo: PersonInfo[]): void {
        const dialogRef = this.createRemarkDialog(yearAndMonth.Year, yearAndMonth.Month, personInfo);
        dialogRef.afterClosed().subscribe((res: { personId: number; dayOfMonth: number; remark: string; }) => {
            if (res) {
                this.processAndRefresh(() => {
                    this.activityRemarkService.createActivityRemark({
                        Key: {
                            WorkplaceId: workplaceId,
                            PersonId: res.personId,
                            Year: yearAndMonth.Year,
                            Month: yearAndMonth.Month + 1,
                            Day: res.dayOfMonth
                        },
                        Remark: res.remark
                    }).subscribe();
                })
            }
        });
    }

    private createRemarkDialog(year: number, month: number, personInfo: PersonInfo[]): MatDialogRef<RemarkDialog> {
        const dialogRef = this.matDialog.open(RemarkDialog, { width: '800px', disableClose: true });
        dialogRef.componentInstance.inputYear = year;
        dialogRef.componentInstance.inputMonth = month;
        dialogRef.componentInstance.personInfo = personInfo;
        return dialogRef;
    }

    private processAndRefresh(action: () => void): void {
        this.overviewService.changeIsProcessing(true);
        action();
        this.overviewService.changeIsProcessing(false);
        this.overviewService.refresh();
    }

    clearActivities(workplaceId: number, yearAndMonth: YearAndMonth): void {
        this.stateService.go(
            "app.activities.clearactivities.with-params",
            {
                workplaceId: workplaceId,
                year: yearAndMonth.Year,
                month: yearAndMonth.Month + 1
            });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/overview/overview.component.ts